import React from 'react';
import {
  AlertsOutlined as Alerts,
  Applications,
  AssetsOutline as Assets,
  Component,
  ComponentInstance,
  CriticalOutline as Critical,
  EntitiesOutlined as Entities,
  FindingsOutline as Findings,
  Applications as Groups,
  IncidentsOutlined as Incidents,
  Object,
  PolicyViolationsOutlined as PolicyViolations,
  Tenant,
  Ticket,
  UserUnfilled as User,
} from '@fabric-ui/icons';

const projColorsMap = {
  default: 'var(--color-content-base-secondary)',
  incidents: 'var(--dataviz-color-categorical-primary-chart06)',
  tickets: 'var(--dataviz-color-sequential-blue-scale05)',
  alertActors: 'var(--dataviz-color-sequential-green-scale04)',
  alerts: 'var(--dataviz-color-categorical-primary-chart09)',
  applications: 'var(--dataviz-color-categorical-primary-chart05)',
  assets: 'var(--dataviz-color-sequential-blue-scale04)',
  componentInstances: 'var(--dataviz-color-sequential-yellow-scale07)',
  components: 'var(--dataviz-color-sequential-cyan-scale05)',
  findings: 'var(--dataviz-color-severity-primary-low)',
  vulnerabilities: 'var(--dataviz-color-sequential-red-scale05)',
  orgEntities: 'var(--dataviz-color-categorical-primary-chart02)',
  uber_policy_populations: 'var(--dataviz-color-categorical-primary-chart02)',
  uber_policy_violations: 'var(--dataviz-color-categorical-primary-chart20)',
  custom: 'var(--dataviz-color-categorical-primary-chart03)',
};

export const ingressProjIcons = {
  alerts: { color: 'transparent', iconColor: projColorsMap.alerts, icon: <Alerts /> },
  alert_actors: { color: 'transparent', iconColor: projColorsMap.alertActors, icon: <Entities /> },
  applications: { color: 'transparent', iconColor: projColorsMap.applications, icon: <Applications /> },
  assets: { color: 'transparent', iconColor: projColorsMap.assets, icon: <Assets /> },
  components: { color: 'transparent', iconColor: projColorsMap.components, icon: <Component /> },
  component_instances: { color: 'transparent', iconColor: projColorsMap.componentInstances, icon: <ComponentInstance /> },
  findings: { color: 'transparent', iconColor: projColorsMap.findings, icon: <Findings /> },
  org_entities: { color: 'transparent', iconColor: projColorsMap.orgEntities, icon: <User /> },
  vulnerabilities: { color: 'transparent', iconColor: projColorsMap.vulnerabilities, icon: <Critical /> },
  defaultIngress: { color: 'transparent', iconColor: projColorsMap.default, icon: <Object /> },
  users: { color: 'transparent', iconColor: projColorsMap.orgEntities, icon: <User /> },
  tenants: { color: 'transparent', iconColor: projColorsMap.orgEntities, icon: <Tenant /> },
  security_groups: { color: 'transparent', iconColor: projColorsMap.orgEntities, icon: <Groups /> },
};

export const uberProjIcons = {
  default: { color: projColorsMap.default, icon: <Object /> },
  incidents: { color: projColorsMap.incidents, icon: <Incidents /> },
  tickets: { color: projColorsMap.tickets, icon: <Ticket /> },
  uber_alert_actors: { color: projColorsMap.alertActors, icon: <Entities /> },
  uber_alerts: { color: projColorsMap.alerts, icon: <Alerts /> },
  uber_applications: { color: projColorsMap.applications, icon: <Applications /> },
  uber_assets: { color: projColorsMap.assets, icon: <Assets /> },
  uber_component_instances: { color: projColorsMap.componentInstances, icon: <ComponentInstance /> },
  uber_components: { color: projColorsMap.components, icon: <Component /> },
  uber_findings: { color: projColorsMap.findings, icon: <Findings /> },
  uber_global_vulnerabilities: { color: projColorsMap.vulnerabilities, icon: <Critical /> },
  uber_org_entities: { color: projColorsMap.orgEntities, icon: <User /> },
  uber_policy_populations: { color: projColorsMap.uber_policy_populations, icon: <PolicyViolations /> },
  uber_policy_violations: { color: projColorsMap.uber_policy_violations, icon: <PolicyViolations /> },
  uber_users: { color: projColorsMap.default, icon: <User /> },
  uber_tenants: { color: projColorsMap.default, icon: <Tenant /> },
  uber_security_groups: { color: projColorsMap.default, icon: <Groups /> },
};
